import { render, staticRenderFns } from "./selectSaleAddons.vue?vue&type=template&id=35fb40de&scoped=true&"
import script from "./selectSaleAddons.vue?vue&type=script&lang=js&"
export * from "./selectSaleAddons.vue?vue&type=script&lang=js&"
import style0 from "./selectSaleAddons.vue?vue&type=style&index=0&id=35fb40de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb40de",
  null
  
)

export default component.exports